import * as Yup from 'yup'
import { AtendimentoType, ModalidadeType } from '../../../../../../../../_metronic/helpers'

type ModalidadeOption = {
  label: string
  value: ModalidadeType
}
export const newAtendimentoSchema = (needEndereco: boolean) =>
  Yup.object().shape({
    tipoAtendimento: Yup.object().nullable().required('Tipo de atendimento é obrigatório'),

    especialidade: Yup.mixed().when('tipoAtendimento.value', (value: AtendimentoType, schema) =>
      value === AtendimentoType.Assistencial || value === AtendimentoType.Especialista
        ? schema.required('Especialidade é obrigatória')
        : schema.nullable()
    ),

    dataAtendimento: Yup.string().required('Data de atendimento é obrigatória'),

    retorno: Yup.boolean(),

    tipoAso: Yup.mixed().when('tipoAtendimento.value', {
      is: AtendimentoType.Ocupacional,
      then: (schema) => schema.required('Tipo de ASO é obrigatório'),
      otherwise: (schema) => schema.nullable(),
    }),

    cliente: Yup.mixed().when('tipoAtendimento.value', {
      is: AtendimentoType.Ocupacional,
      then: (schema) => schema.required('Cliente é obrigatório'),
      otherwise: (schema) => schema.nullable(),
    }),

    responsavel: Yup.mixed().when('tipoAtendimento.value', {
      is: AtendimentoType.Ocupacional,
      then: (schema) => schema.required('Responsável é obrigatório'),
      otherwise: (schema) => schema.nullable(),
    }),

    setor: Yup.mixed().when('tipoAtendimento.value', {
      is: AtendimentoType.Ocupacional,
      then: (schema) => schema.required('Setor é obrigatório'),
      otherwise: (schema) => schema.nullable(),
    }),

    cargo: Yup.mixed().when('tipoAtendimento.value', {
      is: AtendimentoType.Ocupacional,
      then: (schema) => schema.required('Cargo é obrigatório'),
      otherwise: (schema) => schema.nullable(),
    }),

    shouldSend: Yup.boolean().notRequired(),

    telefone: Yup.string()
      .trim()
      .matches(
        /^\(\d{2}\) (\d )?\d{4}-\d{4}$/,
        'Formato deve ser (00) 0000-0000 ou (00) 0 0000-0000'
      )
      .when(['shouldSend', 'email'], {
        is: (shouldSend: boolean, email: string) => shouldSend && (!email || email.trim() === ''),
        then: (schema) => schema.required('Informe telefone ou e-mail'),
        otherwise: (schema) => schema.notRequired(),
      }),

    email: Yup.string().email('E-mail inválido').notRequired(),
    unidade: Yup.object().nullable().notRequired(),
    modalidade: Yup.object().nullable().required('Modalidade de atendimento é obrigatória'),

    enderecoId: Yup.string()
      .nullable()
      .when(['modalidade', 'optionsEnderecos'], {
        is: (modalidade: ModalidadeOption | null, optionsEnderecos: any[]) =>
          modalidade?.value === ModalidadeType.Presencial &&
          optionsEnderecos?.length > 0 &&
          !needEndereco,
        then: (schema) => schema.required('Selecione um endereço'),
        otherwise: (schema) => schema.notRequired(),
      }),

    endereco: Yup.object().when(['modalidade', 'optionsEnderecos'], {
      is: (modalidade: ModalidadeOption | null, optionsEnderecos: any[]) =>
        modalidade?.value === ModalidadeType.Presencial &&
        (optionsEnderecos?.length === 0 || needEndereco),
      then: (schema) =>
        schema.shape({
          nome: Yup.string().required('Nome do endereço obrigatório'),
          cep: Yup.string().required('CEP obrigatório'),
          logradouro: Yup.string().required('Logradouro obrigatório'),
          numero: Yup.string().required('Número obrigatório'),
          complemento: Yup.string().nullable(),
          bairro: Yup.string().required('Bairro obrigatório'),
          cidade: Yup.string().required('Cidade obrigatória'),
          uf: Yup.object().nullable().required('UF obrigatória'),
        }),
      otherwise: (schema) =>
        schema.shape({
          nome: Yup.string().nullable(),
          cep: Yup.string().nullable(),
          logradouro: Yup.string().nullable(),
          numero: Yup.string().nullable(),
          complemento: Yup.string().nullable(),
          bairro: Yup.string().nullable(),
          cidade: Yup.string().nullable(),
          uf: Yup.object().nullable(),
        }),
    }),
  })
